import { combineReducers } from "redux";
import clients from "./clients";
import agents from "./agents";
import chat from "./chat";
import workflows from "./workflows";

export default combineReducers({
  clients,
  agents,
  chat,
  workflows,
});
